<template>
    <v-data-table
        dense
        :headers="headers"
        hide-default-footer
        :items="updateBomProductQuantityItem"
        disable-pagination
    >
      <template v-slot:item.srNo="{item}">
        {{ updateBomProductQuantityItem.indexOf(item)+1  }}
      </template>
    </v-data-table>
</template>
<script>
export default {
  name: 'updatedBomProductQuantity',
  props: {
    product: {
      type: Array,
      default: () => {}
    }
  },
  data () {
    return {
      headers: [
        { text: 'S.No', sortable: true, value: 'srNo' },
        { text: 'Product ID', sortable: true, value: 'Product_ID' },
        { text: 'Product Name', sortable: true, value: 'Product_Name' },
        { text: 'Product Description', sortable: true, value: 'Product_Description' },
        { text: 'Previous BOM Quantity', sortable: true, value: 'previousBomQuantity' },
        { text: 'New BOM Quantity', sortable: true, value: 'newBomQuantity' }
      ],
      updateBomProductQuantityItem: (this.product && this.product.length > 0) ? this.product : []
    }
  },
  watch: {
    product: {
      handler: function (newVal) {
        this.updateBomProductQuantityItem = (newVal && newVal.length > 0) ? newVal : []
      },
      deep: true
    }
  }
}
</script>
